import { render, staticRenderFns } from "./my_trusteeshio_msg.vue?vue&type=template&id=6f2c3d92&scoped=true&"
import script from "./my_trusteeshio_msg.vue?vue&type=script&lang=js&"
export * from "./my_trusteeshio_msg.vue?vue&type=script&lang=js&"
import style0 from "./my_trusteeshio_msg.vue?vue&type=style&index=0&id=6f2c3d92&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c3d92",
  null
  
)

export default component.exports